import { api } from "./paths";
import axios from "axios";

export async function getTeams() {
  const response = await axios.get(api.TEAMS_URL);
  return response.data;
}

